import { CustomerGrowth } from "types/Models/revenueMetrics";
import { MetricChart } from "./RevenueChart";

export const CustomerGrowthCard = ({
  customerGrowth,
}: {
  customerGrowth: CustomerGrowth[];
}) => {
  const chartData = customerGrowth.map((g) => ({
    x: g.period.range,
    y: g.count,
  }));

  return (
    <MetricChart
      title="Customer Growth"
      seriesId="customerGrowth"
      gradientId="customerGrowthArea"
      chartData={chartData}
      emptyTitle="No customers found"
      emptySubtitle="Add transactions to see customers"
      yAxisFormat={(v) => String(v)}
      renderTooltip={(slice) => {
        const point = slice.points[0];
        const currentCount = Number(point.data.y);
        const currentIndex = chartData.findIndex(
          (d) => d.x === point.data.xFormatted
        );
        const prevCount =
          currentIndex > 0 ? chartData[currentIndex - 1].y : null;
        const diff = prevCount !== null ? currentCount - prevCount : null;

        return (
          <div className="t-bg-neutral-100 t-p-3 t-rounded t-text-subtext-sm t-text-white t-min-w-40 t-flex t-flex-col t-gap-1 t-items-center">
            <div className="t-font-semibold">{currentCount} customers</div>
            {diff !== null && (
              <div className="t-text-neutral-30">
                {diff >= 0 ? "+" : ""}
                {diff} vs last month
              </div>
            )}
          </div>
        );
      }}
    />
  );
};
